<template>
  <v-container id="product-view" fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <product-detail v-model="dialog" :product="item" @save="save_product" @clear="clear_product"></product-detail>
        <confirmation-delete v-model="confirmDelete" @excluir="excluir_product" ></confirmation-delete>
        <material-card color="primary" title="Lista de Produtos">
            <v-row>
                <v-col cols="4" >
                    <v-text-field v-model="filtro" label="Pesquisa" placeholder="Filtro de pesquisa" append-icon="mdi-magnify" hide-details dense clearable outlined></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="dialog = true" :disabled="!hasRole(['ADMIN', 'product:create'])" style="margin-right: 1%" outlined>
                    <v-icon left>mdi-plus-circle-outline</v-icon>NOVO PRODUTO
                </v-btn>
            </v-row>
            <v-data-table
                :headers="headers"
                :items="items"
                :loading="loading"
                :search="filtro"
                :key="index"
            >
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn class="ma-2" icon :disabled="item.loading || !hasRole(['ADMIN', 'product:update'])" v-on="on" @click="edit(item)">
                                <v-icon color="primary">mdi-pencil</v-icon>                            
                            </v-btn>
                        </template>
                        <span style="color:#FFF">Editar</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn class="ma-2" icon :disabled="item.loading || !hasRole(['ADMIN', 'product:delete'])" :loading="item.loading_remove" v-on="on" @click="remove(item)">
                                <v-icon color="error">mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span style="color:#FFF">Remover</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/material/Card.vue'
import ConfirmationDelete from '@/components/material/ConfirmationDelete.vue'
import ProductDetail from '@/views/product/Detail.vue'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
export default {
    data: () => ({
        dialog: null,
        loading: null,
        confirmDelete: null,
        headers: [
            { sortable: true, text: '#', value: 'id', width: '30%' },
            { sortable: true, text: 'Nome', value: 'name' },
            { sortable: false, text: 'Ações', value: 'actions', align: 'center', width: '15%' }
        ],
        item: {},
        index: 0
    }),
    mounted() {
        this.search()
    },
    components: {
        MaterialCard,
        ConfirmationDelete,
        ProductDetail
    },
    computed: {
        ...mapState('product', ['filter', 'products']),
        ...mapGetters('app', ['hasRole']),
        filtro: {
            get() { return this.filter },
            set(value) { this.SET_FILTER(value) }
        },
        items: {
            get() { return this.products },
            set(value) { this.SET_PRODUCTS(value) }
        }
    },
    methods: {
        ...mapActions('product', { init_product: 'init' }),
        ...mapMutations('product', ['SET_FILTER', 'SET_PRODUCTS']),
        async search() {
            this.loading = true
            try {
                await this.init_product()
            }
            catch(_) { 
                this.loading = false
            }
            finally {
                this.loading = false
            }
        },
        edit(item) {
            this.item = Object.assign({}, item)
            this.dialog = true
        },
        remove(item) {
            this.item = item
            this.confirmDelete = true
        },
        save_product({ item, isNew }) {
            if (isNew) {
                this.items.push(item)
            }
            else {
                var index = 0
                this.items.forEach(function (c) { 
                    if (c.id == item.id) return ;
                    index++;
                })
                this.items[index] = Object.assign({}, item)
                this.index += 1;
            }
            this.dialog = false
            this.item = {}
        },
        excluir_product() {
            this.confirmDelete = false
            var context = this
            var item = this.items.filter(i => i.id == context.item.id)[0]
            item.loading_remove = true
            this.axios.delete(this.$store.state.url_api + '/product/' + item.id)
                .then(() => {
                    item.loading_remove = false
                    var index = 0
                    context.items.forEach(({ id }) => {
                        if (id == item.id) {
                            context.items.splice(index, 1)
                            return ;   
                        }
                        index++
                    })
                })
                .catch(() => {
                    item.loading_remove = false
                })
            this.item = {}
        },
        clear_product() {
            this.item = {}
        }
    }
}
</script>